(() => {
    // Prevent binding multiple times
    if (window.__LOOKBOOK_SWIPER_BOUND__) return;
    window.__LOOKBOOK_SWIPER_BOUND__ = true;

    let currentWrapperId = null;

    const SELECTORS = {
        activeSlide:
            '.swiper-slide.swiper-slide-visible.swiper-slide-fully-visible.swiper-slide-active',
        targetWrapper: '.bundle-products__product-wrapper.is-current',
        nextBtn: '.swiper-button-next',
        prevBtn: '.swiper-button-prev',
    };

    const getActiveSlideId = () =>
        document.querySelector(SELECTORS.activeSlide)?.id ?? null;

    const toWrapperId = (slideId) => (slideId ? `bundle-products-${slideId}` : null);

    const swapBundleContentBySlide = () => {
        const slideId = getActiveSlideId();
        const wrapperId = toWrapperId(slideId);
        if (!wrapperId || wrapperId === currentWrapperId) return;

        const source = document.getElementById(wrapperId);
        const target = document.querySelector(SELECTORS.targetWrapper);
        if (!source || !target) return;

        target.innerHTML = source.dataset.contentSwpie;

        currentWrapperId = wrapperId;
    };
    const updateSubtotal = (items) => {
        let total = 0;
        let rate = Shopify.currency.rate || 1;
        [...items].forEach((item) => {
            let price = parseFloat(item.dataset.price) * rate;
            total = total + price;
        });
        total = Shopify.formatMoney(total, window.shopMoney.money_format);
        const current = document.querySelector(
            '.bundle-products__item.bundle-products__product-wrapper.is-current'
        );
        const subTotal = current?.querySelector('[id^="BundleSubTotal-"]');

        if (subTotal) subTotal.innerHTML = total;
    };


    const onClick = (e) => {
        const el = e.target;
        if (!(el instanceof Element)) return;
        if (el.classList.contains("lookbook-button-atc")) {
          const current = document.querySelector(
            '.bundle-products__item.bundle-products__product-wrapper.is-current'
        );
        if (current && current.dataset.bundelId){
          const bundelProducts = document.querySelector(`bundle-products[id*="${current.dataset.bundelId}"]`);
          bundelProducts.onButtonClick();
          
        }
        }
        const input = e.target.querySelector('[name="id"]');
        const isNavClick =
            el.closest(SELECTORS.nextBtn) || el.closest(SELECTORS.prevBtn);

        if (isNavClick) {
            requestAnimationFrame(swapBundleContentBySlide);
            return;
        }

        if (input && !input.disabled) {
            const section_id = input.dataset.sectionId;
            const bundleId = input.dataset.bundelId;
            if (section_id) {
                input.checked = !input.checked;
                const submitButtons = document.querySelectorAll(`button[id*="${section_id}"]`);
                const submitButton = [...submitButtons].find((node) => !node.closest('.bundle-products-hidden'));
                if (submitButton && bundleId) {
                    const submitButtonText = submitButton.querySelector('span');
                    const els = document.querySelectorAll(`#bundle-products__list-${section_id}`);
                    const itemsModal = [...els].find((node) => !node.closest('.bundle-products-hidden'));
                    const bundelProduct = itemsModal.querySelector(`#${bundleId}`)
                    bundelProduct.classList.toggle('active');
                    const items = itemsModal.querySelectorAll('[name="id"]:checked:not(:disabled)');

                    submitButtonText.textContent = submitButton.dataset.addToCartText.replace('[count]', items.length);
                    if (items.length == 0) {
                        submitButton.setAttribute('disabled', 'disabled');
                    } else {
                        submitButton.removeAttribute('disabled');
                    }
                    updateSubtotal(items);
                    input.checked = !input.checked;
                }

            }
            return;
        }


    };

    document.addEventListener('click', onClick, true);
})();
